/** 주문실패 케이스 */
export const OrderFailureType = {
    /** 신용카드 한도 부족 또는 네이버페이 잔고 부족 */
    BY_CARD_OR_NAVERPAY: 'BY_CARD_OR_NAVERPAY',
    /** 위험 거래 판단 */
    FDS: 'FDS',
    /** 기타 사유로 주문처리 실패 */
    UNKNOWN: 'UNKNOWN',
    /** 본인이 등록한 상품 결제 불가 */
    BUY_SELF_OWNED: 'BUY_SELF_OWNED',
    /** 판매자에 의해 거절된 구매자 */
    REFUSED_PURCHASER: 'REFUSED_PURCHASER',
    /** 이미 완료된 주문 */
    ORDER_ALREADY_CREATED: 'ORDER_ALREADY_CREATED',
    /** 안전결제 수수료 조회 */
    SAFETY_PURCHASE: 'SAFETY_PURCHASE',
    /** 구매자보호 수수료 조회 */
    GET_FLEAMARKET_PURCHASER_COMMISSIONS_FAILED: 'GET_FLEAMARKET_PURCHASER_COMMISSIONS_FAILED',
    /** 페이지 이동을 위한 주문 불가 */
    BY_REDIRECT: 'BY_REDIRECT',
    /** 유효하지 않은 orderProcessId 로서 주문 실패 */
    POLLING_ABORTED: 'POLLING_ABORTED',
    /** 알비백 보증금 조회 실패 */
    GET_SSG_DEPOSIT_FAILED: 'GET_SSG_DEPOSIT_FAILED',
    // 적립포인트 정책 실패
    GET_REWARD_POLICY_FAILED: 'GET_REWARD_POLICY_FAILED',
} as const

export type OrderFailureTypeType = Constant<typeof OrderFailureType>

/** 패밀리 맴버십 실패 케이스 */
export const FamilyPayFailure = {
    /** 결제요청 받은 패밀리 대표만 결제할 수 있습니다. */
    PAYER_PAY_MEMBER_NO_NOT_MATCHED: 'PAYER_PAY_MEMBER_NO_NOT_MATCHED',
    /** 이미 처리한 주문입니다. */
    ORDER_ALREADY_CREATED: 'ORDER_ALREADY_CREATED',
    /** 요청 받은 상품이 패밀리결제 불가 상품으로 변경되어 결제가 불가합니다. */
    FAILED_CHECK_PRODUCT: 'FAILED_CHECK_PRODUCT',
    REDIRECT: 'REDIRECT',
    /** 기타 사유로 주문처리 실패 */
    UNKNOWN: 'UNKNOWN',
} as const

export type FamilyPayFailureType = Constant<typeof FamilyPayFailure>
